import { QueryKeys, useCustomQuery } from './index';
import fetch from '../../utils/fetchService';
import { handleErrors, parseAsJson } from '../../utils/requestHelpers';

type HeaderName = string;

export type AsyncChildrenRowData = {
  children?: AsyncChildrenRowData[];
  description: string | null,
  expandable: boolean,
  values: Record<HeaderName, unknown>
}

const enqueueTaxExpenseRowDetails = (() => {
  const noop = () => ({});
  let queue: Promise<unknown> = Promise.resolve();

  return <T>(fn: () => Promise<T>) => {
    const run = queue.then(fn);
    // Keep the queue alive even when a request fails.
    queue = run.then(noop, noop);
    return run;
  };
})();

export const useAsyncChildrenRowData = ({ detailsUrl }: { detailsUrl: string }) =>
  useCustomQuery<AsyncChildrenRowData[]>([QueryKeys.reports.TaxExpenseRowDetails, detailsUrl], {
    customFetch: () => enqueueTaxExpenseRowDetails(() =>
      fetch(detailsUrl)
        .then(handleErrors({ errorMessage: 'Error fetching row details' }))
        .then(parseAsJson)
    ),
    defaultData: [],
  });


